/**
 * ring-sizer: 选码工具（输入手指周长 → 推荐 US 码）。
 * 源自 web-hand-off ring-sizer.js：删 partials:loaded，保留 shopify:section:load。
 *
 * 尺寸表来自 HTML（隐藏数据列表 [data-sizer-chart] 内 [data-size]/[data-dia]/[data-circ]，单位 mm），本文件不持有内容。
 * 输入周长 → 换算内径 → 匹配规则对齐品牌《欧美市场测量方案》：
 * 只用 US 整码，测量值介于两码之间一律取大（roundUpIdx，非最近邻）。
 * 2026-08-04 v2：旧版同心圆视觉、单位切换和对比滑块均已下线，本文件只负责「输入 → 推荐码」。
 *
 * 2026-09-03 起在取大结果上再套一个**推荐偏移**（[data-sizer-offset]，section 设置项，
 * 默认 -1）：品牌要求本工具的推荐比尺码表对应的码小一码（量到 7 → 推荐 6）。
 * ⚠️ 净效果 = 先向上取整再减一档，与「介于两码取大」的对外口径相反，实际接近向下取整。
 * ⚠️ 尺码表（chart-modal）与隐藏数据源都**不受偏移影响**，仍是品牌原表——所以推荐码与
 *    尺码表会不一致，这是品牌明确要的行为，不是 bug。
 * 偏移后钳制在「可推荐档」内：下界是首档，上界是最后一个非 [data-anchor-only] 的档。
 *
 * 2026-09-09 起补**越界声明**：实测超出参照系两端时推荐码仍给边界码（US 6 / US 15），
 * 但同时显示 HTML 里的 [data-sizer-note="under"|"over"]，说明那只是最接近的一档并给客服入口 ——
 * 否则用户拿到的是一个看不出问题的推荐值。文案写在 HTML 上，本文件只切换 hidden、不持有内容。
 * 数据源含一个锚点档 US 16（不在售、不进尺码表），只为让 -1 偏移在顶端有落点 ——
 * 否则量到最粗也只能得到 US 14，US 15 会变成任何输入都推不出来的码。
 * 幂等，shopify:section:load 后重新初始化。
 */
(function () {
  var PI = Math.PI;
  // 匹配容差：吸收读数抖动。roundUpIdx 与越界判定共用同一个值。
  var TOL = 0.05;

  function chartOf(root) {
    var page = root.closest('[data-component="support-sizer"]') || document;
    return [...page.querySelectorAll('[data-sizer-chart] [data-size]')].map(function (el) {
      return {
        size: el.dataset.size,
        dia: parseFloat(el.dataset.dia),
        circ: parseFloat(el.dataset.circ),
        // 锚点档只参与取大计算，本身不可作为推荐结果（不在售的 US 16）
        anchorOnly: el.hasAttribute('data-anchor-only')
      };
    });
  }

  // 介于两码之间取大：选择第一个内径 >= 测量值的参照行（TOL 容差吸收读数抖动）。
  // 全表都装不下时返回末行索引，该「落空」情形由调用方按 dia 单独判定（见 recompute 里的 over），
  // 不能只看返回值。
  function roundUpIdx(chart, dia) {
    for (var i = 0; i < chart.length; i++) {
      if (chart[i].dia >= dia - TOL) return i;
    }
    return chart.length - 1;
  }

  // 可被推荐的最大索引：尾部的锚点档（不在售的 US 16）不参与推荐。
  function maxIdxOf(chart) {
    var i = chart.length - 1;
    while (i > 0 && chart[i].anchorOnly) i--;
    return i;
  }

  function set(root, selector, text) {
    var el = root.querySelector(selector);
    if (el) el.textContent = text;
  }

  // 推荐偏移：来自 [data-sizer-offset]，缺失或非数值时按 0 处理（= 纯取大，旧行为）
  function offsetOf(root) {
    var raw = root.getAttribute('data-sizer-offset');
    var n = parseInt(raw, 10);
    return isFinite(n) ? n : 0;
  }

  function recompute(root, chart, offset) {
    var input = root.querySelector('[data-sizer-input]');
    var value = parseFloat(input && input.value);
    if (!isFinite(value) || value <= 0) return;
    var dia = value / PI;
    var maxIdx = maxIdxOf(chart);
    var idx = roundUpIdx(chart, dia) + offset;

    // 越界判定要在钳位【之前】取。两侧不对称：
    // · 下界 = 偏移后掉到 0 以下（实测已在参照系最小行附近，退档后没有更小的码可给）
    // · 上界 = roundUpIdx 落空，即连末行参照（锚点档 US 16）都装不下；**不能用 idx > maxIdx 判**：
    //   offset 为负时命中末行参照后正好落在 maxIdx 上，永远触发不了。
    var under = idx < 0;
    var over = dia > chart[chart.length - 1].dia + TOL;

    // 钳制在「可推荐档」范围内：上界是最后一个非锚点档（锚点档不在售，见 HTML 注释）
    if (idx < 0) idx = 0;
    if (idx > maxIdx) idx = maxIdx;
    // 2026-09-09 起结果区只显示推荐码；dia/circ 读数行已按客户要求移除，
    // 但 chartOf 仍解析这两列 —— dia 参与匹配、circ 保留供查阅。
    set(root, '[data-sizer-size]', 'US ' + chart[idx].size);

    var state = under ? 'under' : over ? 'over' : '';
    root.querySelectorAll('[data-sizer-note]').forEach(function (el) {
      el.hidden = el.getAttribute('data-sizer-note') !== state;
    });
  }

  function init() {
    document.querySelectorAll('[data-sizer]').forEach(function (root) {
      if (root.dataset.sizerReady) return;
      root.dataset.sizerReady = '1';
      var chart = chartOf(root);
      if (!chart.length) return;
      var offset = offsetOf(root);
      var input = root.querySelector('[data-sizer-input]');
      if (input) input.addEventListener('input', function () { recompute(root, chart, offset); });
      recompute(root, chart, offset);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
